import { useNavigate, useParams } from "react-router-dom";
import PlayoutDeliveryEditForm from "../components/playouts/delivery-edit-form";
import { useFeatureFlagQuery } from "../hasura.graphql";

const PlayoutDeliveryByIdEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const role_data = useFeatureFlagQuery();

  return (
    <>
      {role_data.data?.feature_flag.find(
        (feat) => feat.feature === "channel-edit"
      ) !== undefined ? (
        <PlayoutDeliveryEditForm
          close={() => navigate(`/deliveries/playouts/${id}`)}
          deliveryId={id!}
          isModal={false}
        />
      ) : (
        navigate(`/deliveries/playouts/${id}`)
      )}
    </>
  );
};

export default PlayoutDeliveryByIdEdit;
